import { ErrorMessage } from '@hookform/error-message'
import { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useSetRecoilState } from 'recoil'
import { postSendEmail } from '../../../api/mi'
import { SendMiEmail } from '../../../models/miModel'
import { LoginPath } from '../../../routes/path'
import { requestState } from '../../../states/atoms'
import { StyleFormHead } from '../../../styles/mi'
import { Button } from '../../Button'
import { HelperText } from '../../HelperText'
import { Input } from '../Input'

export const SendEmailSection: FC = () => {
  const setRequestState = useSetRecoilState(requestState)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SendMiEmail>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { email: '' },
  })

  const onSubmit = async (data: SendMiEmail) => {
    setRequestState({ isLoading: true })
    try {
      await postSendEmail(data)
      setRequestState({
        isLoading: false,
        completeMessage: `メールの送信が完了しました。\nメールを確認し設定に進んでください。`,
      })
    } catch (error) {
      setRequestState({
        isLoading: false,
        errorMessage: `メールを送信できませんでした。\n時間を置いて再度お試しください。`,
      })
    }
  }

  return (
    <>
      <div className="containerBase">
        <Container>
          <form onSubmit={handleSubmit(onSubmit)} className="miForm">
            <Row>
              <StyleFormHead>
                <img src="/images/miproteger-logo.png" alt="" />
                <p>マイプロテジャーへようこそ</p>
                <div>
                  商品購入時のメールアドレスを登録して
                  <br />
                  マイプロテジャーをはじめましょう。
                </div>
              </StyleFormHead>
            </Row>
            <Row>
              <hr className="solid"></hr>
            </Row>

            <Row>
              <Col className="inputBox">
                <ErrorMessage
                  errors={errors}
                  name="email"
                  render={({ message }) => <HelperText>*{message}</HelperText>}
                />
                <Input
                  type="mail"
                  placeholder="メールアドレス"
                  isError={!!errors.email}
                  {...register('email', {
                    required: 'メールアドレスは必須です',
                    pattern: {
                      value: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i,
                      message: '正しい形式で入力してください',
                    },
                  })}
                />
              </Col>
            </Row>
            <Row>
              <Col className="link-box">
                <div className="link">
                  <a href={LoginPath}>ログインはこちら</a>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="button">
                <Button
                  buttonType="contained"
                  isSubmit
                  onClick={() => undefined}
                  disabled={!!Object.keys(errors).length}
                  isFullWidth
                >
                  メールを送信する
                </Button>
              </Col>
            </Row>
          </form>
        </Container>
      </div>
    </>
  )
}
